import React from 'react';

export const InventoryAdjustmentPrintView = ({ 
  documentData, 
  tableData, 
  decimalPosition,
  calculatePositiveVariation,
  calculateNegativeVariation,
  countPositiveVariationItems,
  countNegativeVariationItems,
  countTotalVariationItems
}) => {
  
  return (
    <div style={{padding: '20px', fontFamily: 'Arial, sans-serif'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '30px', borderBottom: '3px solid #000', paddingBottom: '15px'}}>
        <h1 style={{margin: '0 0 10px 0', fontSize: '24px', color: '#000'}}>
          Inventory Adjustment Report
        </h1>
        <p style={{margin: '5px 0', fontSize: '14px', color: '#666'}}>
          Generated on: {new Date().toLocaleString()}
        </p>
      </div>

      {/* Document Information */}
      <div style={{marginBottom: '15px', backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '3px'}}>
        <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '11px'}}>
          <tbody>
            <tr>
              <td style={{padding: '3px 8px', width: '15%', fontWeight: 'bold'}}>Document:</td>
              <td style={{padding: '3px 8px', width: '35%'}}>{documentData?.name || '-'}</td>
              <td style={{padding: '3px 8px', width: '15%', fontWeight: 'bold'}}>Status:</td>
              <td style={{padding: '3px 8px', width: '35%'}}>{documentData?.status || '-'}</td>
            </tr>
            <tr>
              <td style={{padding: '3px 8px', fontWeight: 'bold'}}>Branch:</td>
              <td style={{padding: '3px 8px'}}>{documentData?.branch?.branchName || '-'}</td>
              <td style={{padding: '3px 8px', fontWeight: 'bold'}}>Location:</td>
              <td style={{padding: '3px 8px'}}>{documentData?.location?.name || '-'}</td>
            </tr>
            <tr>
              <td style={{padding: '3px 8px', fontWeight: 'bold'}}>Adjustment Date:</td>
              <td style={{padding: '3px 8px'}}>{documentData?.adjustmentDate || '-'}</td>
              <td style={{padding: '3px 8px', fontWeight: 'bold'}}>Accounting Date:</td>
              <td style={{padding: '3px 8px'}}>{documentData?.accountingDate || '-'}</td>
            </tr>
            <tr>
              <td style={{padding: '3px 8px', fontWeight: 'bold'}}>Reference:</td>
              <td style={{padding: '3px 8px', colSpan: 3}}>{documentData?.reference || '-'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Summary Counts */}
      <div style={{marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center', fontSize: '11px'}}>
        <span style={{padding: '5px 10px', backgroundColor: '#e3f2fd', border: '1px solid #1100ff', borderRadius: '3px'}}>
          <strong>Product Total:</strong> {tableData?.length || 0}
        </span>
        
        <span style={{padding: '5px 10px', backgroundColor: '#e3f2fd', border: '1px solid #1100ff', borderRadius: '3px'}}>
          <strong>Variation Total:</strong> {countTotalVariationItems ? countTotalVariationItems(tableData) : 0}
        </span>

        {calculatePositiveVariation && calculatePositiveVariation(tableData) > 0 && (
          <span style={{padding: '5px 10px', backgroundColor: '#e8f5e9', border: '1px solid green', borderRadius: '3px'}}>
            <strong style={{color: 'green'}}>Positive:</strong> +{calculatePositiveVariation(tableData).toFixed(decimalPosition)} 
            <span style={{marginLeft: '5px', color: '#666'}}>(Count: {countPositiveVariationItems ? countPositiveVariationItems(tableData) : 0})</span>
          </span>
        )}

        {calculateNegativeVariation && calculateNegativeVariation(tableData) < 0 && (
          <span style={{padding: '5px 10px', backgroundColor: '#ffebee', border: '1px solid red', borderRadius: '3px'}}>
            <strong style={{color: 'red'}}>Negative:</strong> {calculateNegativeVariation(tableData).toFixed(decimalPosition)} 
            <span style={{marginLeft: '5px', color: '#666'}}>(Count: {countNegativeVariationItems ? countNegativeVariationItems(tableData) : 0})</span>
          </span>
        )}
      </div>

      {/* Products Table */}
      <div style={{marginTop: '20px'}}>
        <h3 style={{marginBottom: '15px', fontSize: '18px', borderBottom: '2px solid #000', paddingBottom: '10px'}}>
          Product Details
        </h3>
        <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '12px'}}>
          <thead>
            <tr style={{backgroundColor: '#dee3f8'}}>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'left', fontWeight: 'bold'}}>Product</th>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'center', fontWeight: 'bold'}}>UOM</th>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'right', fontWeight: 'bold'}}>Cost</th>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'right', fontWeight: 'bold'}}>On Hand Qty</th>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'right', fontWeight: 'bold'}}>Real Qty</th>
              <th style={{border: '1px solid #000', padding: '10px', textAlign: 'right', fontWeight: 'bold'}}>Variation</th>
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.map((item, index) => {
              const variation = (Number(item.realQty || 0) - Number(item.stock || 0)).toFixed(decimalPosition);
              const variationColor = variation < 0 ? 'red' : variation > 0 ? 'green' : 'black';
              
              return (
                <tr key={index} style={{backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9'}}>
                  <td style={{border: '1px solid #ccc', padding: '8px'}}>{item.productName || '-'}</td>
                  <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>{item.uomName || '-'}</td>
                  <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>
                    {Number(item.cost || 0).toFixed(decimalPosition)}
                  </td>
                  <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>
                    {Number(item.stock || 0).toFixed(decimalPosition)}
                  </td>
                  <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>
                    {Number(item.realQty || 0).toFixed(decimalPosition)}
                  </td>
                  <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: variationColor, fontWeight: 'bold'}}>
                    {variation > 0 ? '+' : ''}{variation}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{marginTop: '40px', paddingTop: '20px', borderTop: '2px solid #ccc', fontSize: '11px', color: '#666', textAlign: 'center'}}>
        <p style={{margin: '5px 0'}}>This is a system-generated report</p>
        <p style={{margin: '5px 0'}}>Printed on: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
};
